<div class="container-lg">
    <h1>Votre message a bien été envoyé</h1>
    
    <p class="p1-confirm-message"><span>HEAT TRAINING</span> vous remercie pour votre message.</p>
    <p class="pb-3">Une personne de l'équipe prendra rapidement connaissance de ce dernier et vous recontactera au plus vite.</p>
    <p class="p2-confirm-message">Vous pouvez retourner à la page principal, en cliquant sur le bouton</p>
    <a routerLink="/" class="lien-home-from-confirm">
        <button class="btn">Retour à la page d'accueil</button>
    </a>
</div>
